import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  p {\n    margin: 0;\n  }\n\n  .filter-title-wrapper {\n    cursor: pointer;\n    height: 45px;\n    padding: 0 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid ",
        ";\n  }\n\n  p {\n    font-size: 14px;\n    font-weight: 600;\n    color: ",
        ";\n  }\n\n  .ant-btn {\n    border: none;\n  }\n\n  .filter-list-wrapper {\n  }\n\n  .title-expanding {\n    background-color: ",
        ";\n    border-bottom: 1px solid ",
        ";\n\n    p {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { MobileFilterListItem } from "@/components/Search/MobileFilterListItem";
import React from "react";
import styled from "styled-components";
import { FilterTypeToQueryKey, findLabel } from "../../../api/booksProducts";
export const BookListMobileFilterList = (param)=>{
    let { handleFilter , filters , selectedFilters , openSlider , sliderOpen  } = param;
    return /*#__PURE__*/ _jsx(BooksMobileFilterListWrapper, {
        children: /*#__PURE__*/ _jsx("ul", {
            children: Object.keys(filters).map((key, idx)=>{
                const newFilters = filters[key].map((item)=>{
                    return {
                        id: item,
                        value: item,
                        label: findLabel(FilterTypeToQueryKey[key], item)
                    };
                });
                if (filters[key].length > 0) return /*#__PURE__*/ _jsx("li", {
                    children: /*#__PURE__*/ _jsx(MobileFilterListItem, {
                        title: FilterTypeToQueryKey[key],
                        filterItem: newFilters,
                        handleFilter: handleFilter,
                        selectedFilters: selectedFilters,
                        openSlider: openSlider,
                        sliderOpen: sliderOpen
                    })
                }, idx);
            })
        })
    });
};
export const BooksMobileFilterListWrapper = styled.div.withConfig({
    componentId: "sc-652079ed-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_900);
